const CACHE_PREFIX = 'sb_offline_';
const DEFAULT_TTL = 30 * 60 * 1000; // 30 minutes

// Routes to cache for offline reading
const CACHEABLE_ROUTES = [
  { pattern: '/wallet/balance', ttl: 15 * 60 * 1000 },
  { pattern: '/shipments/list', ttl: 10 * 60 * 1000 },
  { pattern: '/analytics/merchant/charts-data', ttl: 30 * 60 * 1000 },
  { pattern: '/warehouses/list', ttl: 60 * 60 * 1000 },
  { pattern: '/merchant/profile', ttl: 60 * 60 * 1000 },
  { pattern: '/b2b/shipments', ttl: 10 * 60 * 1000 },
  { pattern: '/b2b/wallet/balance', ttl: 15 * 60 * 1000 },
];

function getCacheKey(url) {
  return CACHE_PREFIX + url.replace(/[^a-zA-Z0-9]/g, '_');
}

function findCacheConfig(url) {
  return CACHEABLE_ROUTES.find(r => url.includes(r.pattern));
}

export function shouldCacheRoute(url) {
  return !!findCacheConfig(url);
}

export function cacheResponse(url, data) {
  const config = findCacheConfig(url);
  if (!config) return;

  try {
    const entry = {
      data,
      timestamp: Date.now(),
      ttl: config.ttl || DEFAULT_TTL,
    };
    localStorage.setItem(getCacheKey(url), JSON.stringify(entry));
  } catch (e) {
    // localStorage full — clear old entries
    clearExpiredCache();
  }
}

export function getCachedResponse(url) {
  const key = getCacheKey(url);
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const entry = JSON.parse(raw);
    const age = Date.now() - entry.timestamp;
    // Return even if expired when offline — stale data is better than no data
    return { data: entry.data, stale: age > entry.ttl };
  } catch {
    return null;
  }
}

export function clearExpiredCache() {
  const keys = Object.keys(localStorage).filter(k => k.startsWith(CACHE_PREFIX));
  keys.forEach(key => {
    try {
      const entry = JSON.parse(localStorage.getItem(key));
      if (Date.now() - entry.timestamp > entry.ttl * 3) {
        localStorage.removeItem(key);
      }
    } catch {
      localStorage.removeItem(key);
    }
  });
}

export function clearAllOfflineCache() {
  Object.keys(localStorage)
    .filter(k => k.startsWith(CACHE_PREFIX))
    .forEach(k => localStorage.removeItem(k));
}
